package com.ragnorak.clanybackoffice.ui.theme

import androidx.compose.ui.graphics.Color

val light_primary = Color(0xFFF4A261) // Oro Suave
val light_onPrimary = Color(0xFFFFFFFF) // Blanco para contraste
val light_primaryContainer = Color(0xFFFBDEBC) // Tono más claro del oro suave
val light_onPrimaryContainer = Color(0xFF271904) // Contraste oscuro sobre el contenedor

val light_secondary = Color(0xFF009688) // Teal 500
val light_onSecondary = Color(0xFFFFFFFF) // White for contrast
val light_secondaryContainer = Color(0xFFB2DFDB) // Teal 100
val light_onSecondaryContainer = Color(0xFF000000) // Black on primary container

val light_tertiary = Color(0xFFFF6B6B)
val light_onTertiary = Color(0xFFFFFFFF)
val light_tertiaryContainer = Color(0xFFFFDAD6)
val light_onTertiaryContainer = Color(0xFF410002)

val light_error = Color(0xFFBA1A1A) // Rojo de error estándar
val light_errorContainer = Color(0xFFFFDAD6) // Contenedor de error más claro
val light_onError = Color(0xFFFFFFFF) // Blanco sobre error
val light_onErrorContainer = Color(0xFF410002) // Contraste oscuro sobre contenedor de error

val light_background = Color(0xFFFFFBFF) // Fondo blanco
val light_onBackground = Color(0xFF1F1B16) // Texto oscuro sobre fondo claro
val light_surface = Color(0xFFFFFBFF) // Superficie blanca
val light_onSurface = Color(0xFF1F1B16) // Texto oscuro sobre superficie

val light_surfaceVariant = Color(0xFFF0E0CF) // Variante de superficie más cálida
val light_onSurfaceVariant = Color(0xFF4F4539) // Texto sobre superficie variante
val light_outline = Color(0xFF817567) // Líneas de separación
val light_inverseOnSurface = Color(0xFFF9EFE7) // Contraste claro sobre fondo oscuro
val light_inverseSurface = Color(0xFF34302A) // Contraste oscuro sobre fondo claro
val light_inversePrimary = Color(0xFFFFB951) // Versión más cálida del primario
val light_shadow = Color(0xFF000000) // Sombras en negro
val light_surfaceTint = Color(0xFF825500) // Tinte de la superficie
val light_outlineVariant = Color(0xFFD3C4B4) // Variante más clara de los bordes
val light_scrim = Color(0xFF000000) // Opacidad sobre fondos oscuros

val dark_primary = Color(0xFFC08450) // Oro Suave en versión oscura
val dark_onPrimary = Color(0xFFFFFFFF) // Contraste más oscuro
val dark_primaryContainer = Color(0xFF56442A) // Contenedor secundario oscuro
val dark_onPrimaryContainer = Color(0xFFFBDEBC) // Texto sobre contenedor secundario

val dark_secondary = Color(0xFF80CBC4) // Teal 200
val dark_onSecondary = Color(0xFF000000) // Black for contrast
val dark_secondaryContainer = Color(0xFF00796B) // Teal 700
val dark_onSecondaryContainer = Color(0xFFFFFFFF) // White on primary container

val dark_tertiary = Color(0xFFFFB4AB) // Coral suave
val dark_onTertiary = Color(0xFF690005)
val dark_tertiaryContainer = Color(0xFF93000A)
val dark_onTertiaryContainer = Color(0xFFFFDAD6)

val dark_error = Color(0xFFFE4949) // Rojo error versión oscura
val dark_errorContainer = Color(0xFF93000A) // Contenedor de error oscuro
val dark_onError = Color(0xFF690005) // Contraste sobre error
val dark_onErrorContainer = Color(0xFFFFDAD6) // Texto sobre error container

val dark_background = Color(0xFF1F1B16) // Fondo oscuro
val dark_onBackground = Color(0xFFEAE1D9) // Texto claro sobre fondo oscuro
val dark_surface = Color(0xFF1F1B16) // Superficie oscura
val dark_onSurface = Color(0xFFEAE1D9) // Texto claro sobre superficie

val dark_surfaceVariant = Color(0xFF4F4539) // Variante de superficie más cálida
val dark_onSurfaceVariant = Color(0xFFD3C4B4) // Texto sobre superficie variante
val dark_outline = Color(0xFF9C8F80) // Líneas de separación
val dark_inverseOnSurface = Color(0xFF1F1B16) // Contraste oscuro sobre fondo claro
val dark_inverseSurface = Color(0xFFEAE1D9) // Contraste claro sobre fondo oscuro
val dark_inversePrimary = Color(0xFF825500) // Versión más cálida del primario
val dark_shadow = Color(0xFF000000) // Sombras en negro
val dark_surfaceTint = Color(0xFFFFB951) // Tinte de la superficie
val dark_outlineVariant = Color(0xFF4F4539) // Variante más clara de los bordes
val dark_scrim = Color(0xFF000000) // Opacidad sobre fondos oscuros
